import React, { useState } from 'react';
import {
  Grid,
  Typography,
  Box,
  Divider,
  TextField,
  Button,
  useMediaQuery,
  Container,
  Paper,
  CircularProgress,
  Fade,
  Grow
} from '@mui/material';
import { useForm } from 'react-hook-form';
import './style.scss';
import './style.scss';
import { useSelector, useDispatch } from 'react-redux';
import { addFranchise } from '../../actions/franchise';
import Snackbarcomponent from '../snackbar/snackbar';

const FranchiseDataForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const isMobile = useMediaQuery('(max-width:768px)');
  const isTablet = useMediaQuery('(max-width:1024px)');
  
  const defaultSnackbarData = {
    show: false,
    msg: '',
    severity: ''
  };
  const [snackbarData, setSnackbarData] = useState(defaultSnackbarData);

  const onSubmit = async data => {
    setLoading(true);
    const res = await dispatch(addFranchise({ data }));

    setLoading(false);
    if (res.type === 'add/franchise/fulfilled') {
      setSnackbarData({
        show: true,
        msg: 'Your request has been submitted',
        severity: 'success'
      });
      reset();
    } else {
      setSnackbarData({
        show: true,
        msg: 'Your request has been failed. Please try again.',
        severity: 'error'
      });
    }
  };

  return (
    <Box 
      sx={{ 
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        py: { xs: 3, sm: 4, md: 6 },
        px: { xs: 1, sm: 2 }
      }}
    >
      <Container maxWidth="lg">
        <Fade in={true} timeout={800}>
          <Box>
            {/* Header Section */}
            <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 6 } }}>
              <Typography 
                variant="h3"
                sx={{
                  fontSize: { xs: '28px', sm: '36px', md: '44px' },
                  fontWeight: '700',
                  color: 'white',
                  mb: 2,
                  textShadow: '0 2px 10px rgba(0,0,0,0.3)',
                  fontFamily: 'inherit'
                }}
              >
                Join Our Franchise Network
              </Typography>
              <Typography 
                variant="h6"
                sx={{
                  fontSize: { xs: '16px', sm: '18px', md: '20px' },
                  color: 'rgba(255,255,255,0.9)',
                  fontWeight: '400',
                  maxWidth: '600px',
                  mx: 'auto',
                  lineHeight: 1.5
                }}
              >
                Request a Call Back by Filling this Form
              </Typography>
              <Divider 
                sx={{ 
                  width: '80px', 
                  height: '4px', 
                  backgroundColor: '#FFD700',
                  borderRadius: '2px',
                  mx: 'auto', 
                  mt: 3,
                  boxShadow: '0 2px 10px rgba(255,215,0,0.5)'
                }} 
              />
            </Box>

            <Snackbarcomponent
              open={snackbarData.show}
              snackDetails={{
                msg: snackbarData.msg,
                severity: snackbarData.severity
              }}
              handlerForSnack={() => setSnackbarData(defaultSnackbarData)}
            />

            {/* Form Section */}
            <Grow in={true} timeout={1000}>
              <Paper 
                elevation={24}
                sx={{
                  borderRadius: { xs: 2, md: 4 },
                  overflow: 'hidden',
                  background: 'rgba(255,255,255,0.95)',
                  backdropFilter: 'blur(20px)',
                  border: '1px solid rgba(255,255,255,0.2)',
                  boxShadow: '0 20px 60px rgba(0,0,0,0.1)'
                }}
              >
                <Box sx={{ p: { xs: 3, sm: 4, md: 6 } }}>
                  <Grid container spacing={{ xs: 3, md: 4 }}>
                    {/* Left Column */}
                    <Grid item xs={12} lg={6}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                        <Box>
                          <Typography 
                            sx={{
                              fontSize: '16px',
                              fontWeight: '600',
                              color: '#2c3e50',
                              mb: 1,
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              '&::before': {
                                content: '"👤"',
                                fontSize: '18px'
                              }
                            }}
                          >
                            Full Name
                          </Typography>
                          <TextField
                            {...register('name', { required: 'Please fill your name' })}
                            fullWidth
                            placeholder='Enter your name'
                            error={!!errors?.name}
                            helperText={errors?.name?.message}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                                backgroundColor: '#f8f9ff',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                  backgroundColor: '#fff',
                                  '& fieldset': {
                                    borderColor: '#667eea',
                                  },
                                },
                                '&.Mui-focused': {
                                  backgroundColor: '#fff',
                                  '& fieldset': {
                                    borderColor: '#667eea',
                                    borderWidth: '2px',
                                  },
                                },
                                '& input': {
                                  padding: '14px 16px',
                                }
                              },
                            }}
                          />
                        </Box>

                        <Box>
                          <Typography 
                            sx={{
                              fontSize: '16px',
                              fontWeight: '600',
                              color: '#2c3e50',
                              mb: 1,
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              '&::before': {
                                content: '"📱"',
                                fontSize: '18px'
                              }
                            }}
                          >
                            Mobile Number
                          </Typography>
                          <TextField
                            {...register('phone_no', { required: 'Please fill your phone number' })}
                            fullWidth
                            placeholder='Enter your phone number'
                            error={!!errors?.phone_no}
                            helperText={errors?.phone_no?.message}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                                backgroundColor: '#f8f9ff',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                  backgroundColor: '#fff',
                                  '& fieldset': {
                                    borderColor: '#667eea',
                                  },
                                },
                                '&.Mui-focused': {
                                  backgroundColor: '#fff',
                                  '& fieldset': {
                                    borderColor: '#667eea',
                                    borderWidth: '2px',
                                  },
                                },
                                '& input': {
                                  padding: '14px 16px',
                                }
                              },
                            }}
                          />
                        </Box>

                        <Box>
                          <Typography 
                            sx={{
                              fontSize: '16px',
                              fontWeight: '600',
                              color: '#2c3e50',
                              mb: 1,
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              '&::before': {
                                content: '"✉️"',
                                fontSize: '18px'
                              }
                            }}
                          >
                            Email ID
                          </Typography>
                          <TextField
                            {...register('email', { required: 'Please fill your email' })}
                            fullWidth
                            placeholder='Enter your email id'
                            error={!!errors?.email}
                            helperText={errors?.email?.message}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                                backgroundColor: '#f8f9ff',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                  backgroundColor: '#fff',
                                  '& fieldset': {
                                    borderColor: '#667eea',
                                  },
                                },
                                '&.Mui-focused': {
                                  backgroundColor: '#fff',
                                  '& fieldset': {
                                    borderColor: '#667eea',
                                    borderWidth: '2px',
                                  },
                                },
                                '& input': {
                                  padding: '14px 16px',
                                }
                              },
                            }}
                          />
                        </Box>

                        <Box>
                          <Typography 
                            sx={{
                              fontSize: '16px',
                              fontWeight: '600',
                              color: '#2c3e50',
                              mb: 1,
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              '&::before': {
                                content: '"📍"',
                                fontSize: '18px'
                              }
                            }}
                          >
                            Location
                          </Typography>
                          <TextField
                            {...register('location', { required: 'Please fill your location' })}
                            fullWidth
                            placeholder='Enter your location'
                            error={!!errors?.location}
                            helperText={errors?.location?.message}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                                backgroundColor: '#f8f9ff',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                  backgroundColor: '#fff',
                                  '& fieldset': {
                                    borderColor: '#667eea',
                                  },
                                },
                                '&.Mui-focused': {
                                  backgroundColor: '#fff',
                                  '& fieldset': {
                                    borderColor: '#667eea',
                                    borderWidth: '2px',
                                  },
                                },
                                '& input': {
                                  padding: '14px 16px',
                                }
                              },
                            }}
                          />
                        </Box>
                      </Box>
                    </Grid>

                    {/* Right Column */}
                    <Grid item xs={12} lg={6}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                        <Box>
                          <Typography 
                            sx={{
                              fontSize: '16px',
                              fontWeight: '600',
                              color: '#2c3e50',
                              mb: 1,
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              '&::before': {
                                content: '"🏢"',
                                fontSize: '18px'
                              }
                            }}
                          >
                            Total Available Area
                          </Typography>
                          <TextField
                            {...register('available_area', { required: 'Please fill available area' })}
                            fullWidth
                            placeholder='Enter the available area'
                            error={!!errors?.available_area}
                            helperText={errors?.available_area?.message}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                                backgroundColor: '#f8f9ff',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                  backgroundColor: '#fff',
                                  '& fieldset': {
                                    borderColor: '#667eea',
                                  },
                                },
                                '&.Mui-focused': {
                                  backgroundColor: '#fff',
                                  '& fieldset': {
                                    borderColor: '#667eea',
                                    borderWidth: '2px',
                                  },
                                },
                                '& input': {
                                  padding: '14px 16px',
                                }
                              },
                            }}
                          />
                        </Box>

                        <Box>
                          <Typography 
                            sx={{
                              fontSize: '16px',
                              fontWeight: '600',
                              color: '#2c3e50',
                              mb: 1,
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              '&::before': {
                                content: '"💰"',
                                fontSize: '18px'
                              }
                            }}
                          >
                            Available Investment
                          </Typography>
                          <TextField
                            {...register('available_investment', { required: 'Please fill available investment' })}
                            fullWidth
                            placeholder='Enter your available investment'
                            error={!!errors?.available_investment}
                            helperText={errors?.available_investment?.message}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                                backgroundColor: '#f8f9ff',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                  backgroundColor: '#fff',
                                  '& fieldset': {
                                    borderColor: '#667eea',
                                  },
                                },
                                '&.Mui-focused': {
                                  backgroundColor: '#fff',
                                  '& fieldset': {
                                    borderColor: '#667eea',
                                    borderWidth: '2px',
                                  },
                                },
                                '& input': {
                                  padding: '14px 16px',
                                }
                              },
                            }}
                          />
                        </Box>

                        <Box>
                          <Typography 
                            sx={{
                              fontSize: '16px',
                              fontWeight: '600',
                              color: '#2c3e50',
                              mb: 1,
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              '&::before': {
                                content: '"🕒"',
                                fontSize: '18px'
                              }
                            }}
                          >
                            Suitable Date & Time
                          </Typography>
                          <TextField
                            {...register('suitable_timings', { required: 'Please fill suitable timings' })}
                            fullWidth
                            placeholder='Enter the suitable timings'
                            multiline
                            rows={5}
                            error={!!errors?.suitable_timings}
                            helperText={errors?.suitable_timings?.message}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                                backgroundColor: '#f8f9ff',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                  backgroundColor: '#fff',
                                  '& fieldset': {
                                    borderColor: '#667eea',
                                  },
                                },
                                '&.Mui-focused': {
                                  backgroundColor: '#fff',
                                  '& fieldset': {
                                    borderColor: '#667eea',
                                    borderWidth: '2px',
                                  },
                                },
                                '& textarea': {
                                  padding: '14px 16px',
                                }
                              },
                            }}
                          />
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>

                  {/* Submit Button */}
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: { xs: 4, md: 6 } }}>
                    <Button
                      variant='contained'
                      size="large"
                      disabled={loading}
                      onClick={handleSubmit(onSubmit)}
                      sx={{
                        background: loading ? '#ccc' : 'linear-gradient(45deg, #2CC248 30%, #1e8e33 90%)',
                        boxShadow: loading ? 'none' : '0px 8px 25px rgba(44, 194, 72, 0.4)',
                        borderRadius: '50px',
                        padding: { xs: '12px 40px', sm: '15px 60px' },
                        fontSize: { xs: '18px', sm: '22px' },
                        fontWeight: '600',
                        textTransform: 'none',
                        minWidth: { xs: '200px', sm: '250px' },
                        height: { xs: '50px', sm: '60px' },
                        position: 'relative',
                        overflow: 'hidden',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          background: loading ? '#ccc' : 'linear-gradient(45deg, #1e8e33 30%, #156b27 90%)',
                          boxShadow: loading ? 'none' : '0px 12px 35px rgba(44, 194, 72, 0.5)',
                          transform: loading ? 'none' : 'translateY(-2px)',
                        },
                        '&:active': {
                          transform: loading ? 'none' : 'translateY(0px)',
                        },
                        '&::before': {
                          content: '""',
                          position: 'absolute',
                          top: 0,
                          left: '-100%',
                          width: '100%',
                          height: '100%',
                          background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
                          transition: 'left 0.5s',
                        },
                        '&:hover::before': {
                          left: '100%',
                        }
                      }}
                    >
                      {loading ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <CircularProgress size={24} sx={{ color: 'white' }} />
                          <Typography sx={{ fontSize: 'inherit', fontWeight: 'inherit' }}>
                            Submitting...
                          </Typography>
                        </Box>
                      ) : (
                        'Submit Request'
                      )}
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Grow>

            {/* Footer Info */}
            <Box sx={{ textAlign: 'center', mt: 4 }}>
              <Typography 
                sx={{ 
                  color: 'rgba(255,255,255,0.8)', 
                  fontSize: '14px',
                  fontWeight: '400'
                }}
              >
                We'll get back to you within 24 hours
              </Typography>
            </Box>
          </Box>
        </Fade>
      </Container>
    </Box>
  );
};

export default FranchiseDataForm;